module.exports = __webpack_public_path__ + "img/createc-logo.5344eb91.png";